import React, { useState, useEffect } from 'react';
import { FiCalendar } from 'react-icons/fi';

const PrintReceiptForm = ({ isOpen, onClose, certificateData, onSave, defaultRemark = 'प्रत छपाईचे रोख जमा' }) => {
  const [formData, setFormData] = useState({
    outwardNo: '',
    paymentTaken: 'Yes',
    payerName: '',
    amount: '',
    receiptDate: '2025-04-01', // Default
    receiptNo: '',
    remark: defaultRemark // Default remark using prop
  });

  useEffect(() => {
    if (certificateData) {
      setFormData(prev => ({
        ...prev,
        payerName: certificateData.personName || ''
        // You can populate other fields if available in certificateData
      }));
    }
  }, [certificateData]);


  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onSave && onSave(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl overflow-hidden">
        
        {/* Header */}
        <div className="bg-[#267c77] text-white p-3 px-6">
          <h2 className="text-xl font-semibold">प्रत छापण्याबद्दलची पावती</h2>
        </div>

        {/* Content */}
        <div className="p-8 space-y-5">
            
            {/* Outward No */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="text-gray-700 md:col-span-1">जावक नं.</label>
                <div className="md:col-span-2">
                     <input 
                        type="text" 
                        name="outwardNo"
                        value={formData.outwardNo}
                        onChange={handleInputChange}
                        placeholder="जावक नंबर भरा."
                        className="w-full p-2 border border-[#267c77]/30 rounded"
                     />
                </div>
            </div>

            {/* Payment Taken */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="text-gray-700 md:col-span-1">प्रत छापण्यासाठी पैसे घ्यायचे आहेत का</label>
                <div className="md:col-span-2 flex items-center gap-4 bg-cyan-400/30 p-2 rounded w-fit px-4">
                     <div className="flex items-center">
                        <input 
                            type="radio" 
                            name="paymentTaken" 
                            id="auditLogYes"
                            value="Yes"
                            checked={formData.paymentTaken === 'Yes'}
                            onChange={handleInputChange}
                            className="mr-2 w-4 h-4 text-black bg-black border-gray-300 focus:ring-black"
                        />
                        <label htmlFor="auditLogYes" className="text-gray-700">होय</label>
                     </div>
                     <div className="flex items-center">
                        <input 
                            type="radio" 
                            name="paymentTaken" 
                            id="auditLogNo"
                            value="No"
                            checked={formData.paymentTaken === 'No'}
                            onChange={handleInputChange}
                            className="mr-2 w-4 h-4 text-black border-gray-300 focus:ring-black"
                        />
                        <label htmlFor="auditLogNo" className="text-gray-700">नाही</label>
                     </div>
                </div>
            </div>

            {/* Payer Name */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="text-gray-700 md:col-span-1">रक्कम देणाराचे नाव</label>
                <div className="md:col-span-3">
                     <input 
                        type="text" 
                        name="payerName"
                        value={formData.payerName}
                        onChange={handleInputChange}
                        placeholder="रक्कम देणाराचे नाव भरा."
                        className="w-full p-2 border border-[#267c77]/30 rounded"
                     />
                </div>
            </div>

             {/* Amount */}
             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="text-gray-700 md:col-span-1">प्रत छपाई रक्कम</label>
                <div className="md:col-span-2">
                     <input 
                        type="text" 
                        name="amount"
                        value={formData.amount}
                        onChange={handleInputChange}
                        placeholder="प्रत छपाई रक्कम भरा."
                        className="w-full p-2 border border-[#267c77]/30 rounded"
                     />
                </div>
            </div>

            {/* Receipt Date */}
             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="text-gray-700 md:col-span-1">पावती दिनांक</label>
                <div className="md:col-span-2 relative">
                     <input 
                        type="date"
                        name="receiptDate"
                        value={formData.receiptDate}
                        onChange={handleInputChange} 
                        className="w-full p-2 border border-gray-200 bg-gray-100 rounded"
                     />
                </div>
            </div>

             {/* Receipt No */}
             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                <label className="text-gray-700 md:col-span-1">पावती क्र.</label>
                <div className="md:col-span-2">
                     <input 
                        type="text" 
                        name="receiptNo"
                        value={formData.receiptNo}
                        onChange={handleInputChange}
                        placeholder="पावती क्रमांक भरा."
                        className="w-full p-2 border border-[#267c77]/30 rounded"
                     />
                </div>
            </div>

             {/* Remark */}
             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
                <label className="text-gray-700 md:col-span-1 mt-2">शेरा</label>
                <div className="md:col-span-3">
                     <textarea 
                        name="remark"
                        value={formData.remark}
                        onChange={handleInputChange}
                        rows="2"
                        className="w-full p-2 border border-[#267c77]/30 rounded resize-none"
                     />
                </div>
            </div>

             {/* Footer Buttons */}
             <div className="mt-8 flex justify-center gap-4">
                <button 
                  onClick={handleSubmit}
                  className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
                >
                    ठिक
                </button>
                <button 
                  onClick={onClose}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition font-medium"
                >
                    रद्द करा
                </button>
             </div>
        </div>
      </div>
    </div>
  );
};

export default PrintReceiptForm;
